// src/config/Plans.js

// Pricing plans structure for the application
export const PRICING_PLANS = {
  Teacher: [
    {
      title: 'Starter',
      code: 'teacher_starter',
      price: 'Free',
      period: '',
      duration: 'onetime',
      buttonText: 'Get Started',
      checkoutNeeded: 'no',
      features: {
        'No of Tests': '5',
        'Max no of Students': '2',
        'Question bank access': 'Yes',
        'Test Report and add notes': 'X',
        'Email support': 'X',
        'Create tests from your own question bank': 'X',
        'Detailed performance analytics': 'X',
        'Adaptive Exam Planner': 'X',
        'Dedicated success manager': 'X',
        'Custom integrations': 'X',
        'Onboarding & training': 'X',
        'Whitelabeling': 'X'
      }
    },
    {
      title: 'Pro',
      code: 'teacher_pro',
      price: 'A$15',
      period: '/month',
      duration: 'monthly',
      buttonText: 'Start Free Trial',
      isRecommended: true,
      checkoutNeeded: 'yes',
      features: {
        'No of Tests': '20 / month',
        'Max no of Students': '5',
        'Question bank access': 'Yes',
        'Test Report and add notes': 'Yes',
        'Email support': 'Yes',
        'Create tests from your own question bank': 'Yes',
        'Detailed performance analytics': 'Yes',
        'Adaptive Exam Planner': 'Yes',
        'Dedicated success manager': 'X',
        'Custom integrations': 'X',
        'Onboarding & training': 'X',
        'Whitelabeling': 'X'
      }
    },
    {
      title: 'School',
      code: 'teacher_school',
      price: 'Custom',
      period: '',
      duration: 'custom',
      buttonText: 'Contact Us',
      checkoutNeeded: 'yes',
      features: {
        'No of Tests': 'Custom',
        'Max no of Students': 'Custom',
        'Question bank access': 'Yes',
        'Test Report and add notes': 'Yes',
        'Email support': 'Yes',
        'Create tests from your own question bank': 'Yes',
        'Detailed performance analytics': 'Yes',
        'Adaptive Exam Planner': 'Yes',
        'Dedicated success manager': 'Yes',
        'Custom integrations': 'Yes',
        'Onboarding & training': 'Yes',
        'Whitelabeling': 'Yes'
      }
    }
  ],
  Student: [
    {
      title: 'Starter',
      code: 'student_starter',
      price: 'Free',
      period: '',
      duration: 'onetime',
      buttonText: 'Get Started',
      checkoutNeeded: 'no',
      features: {
        'No of Tests,Create your own': '5',
        'Teacher Assisted Tests': '0',
        'Track performance': 'X',
        'Maintain revision notes': 'X',
        'Email support': 'X',
        'Detailed Performance analytics': 'X',
        'Adaptive Exam Planner': 'X',
        'Upload Worksheets,tailored feedback by Teacher': 'X',
      }
    },
    {
      title: 'Pro',
      code: 'student_pro',
      price: 'A$9.99',
      period: '/month',
      duration: 'monthly',
      buttonText: 'Start Free Trial',
      isRecommended: true,
      checkoutNeeded: 'yes',
      features: {
        'No of Tests,Create your own': '20 / month',
        'Teacher Assisted Tests': '0',
        'Track performance': 'Yes',
        'Maintain revision notes': 'Yes',
        'Email support': 'Yes',
        'Detailed Performance analytics': 'Yes',
        'Adaptive Exam Planner': 'Yes',
        'Upload Worksheets,tailored feedback by Teacher': 'X',
      }
    },
    {
      title: 'Teacher Assisted',
      code: 'teacher_assisted',
      price: 'A$19.99',
      period: '/month',
      duration: 'monthly',
      buttonText: 'Sign Up',
      checkoutNeeded: 'yes',
      features: {
        'No of Tests,Create your own': '20 / month',
        'Teacher Assisted Tests': '10 / month',
        'Track performance': 'Yes',
        'Maintain revision notes': 'Yes',
        'Email support': 'Yes',
        'Detailed Performance analytics': 'Yes',
        'Adaptive Exam Planner': 'Yes',
        'Upload Worksheets,tailored feedback by Teacher': 'Yes',
      }
    }
  ],
  Parent: [
    {
      title: 'Family Starter',
      code: 'family_starter',
      price: 'Free',
      period: '',
      duration: 'onetime',
      buttonText: 'Get Started',
      checkoutNeeded: 'no',
      features: {
        'No of Tests,Create your own': '5',
        'Teacher Assisted Tests': '0',
        'Max No of Children': '5',
        'Track performance': 'X',
        'Maintain revision notes': 'X',
        'Weekly email updates': 'X',
        'Email support': 'X',
        'Detailed Performance analytics': 'X',
        'Adaptive Exam Planner': 'X',
        'Upload Worksheets,tailored feedback by Teacher': 'X',
      }
    },
    {
      title: 'Family Pro',
      code: 'family_pro',
      price: 'A$9.99',
      period: '/month',
      duration: 'monthly',
      buttonText: 'Start Free Trial',
      isRecommended: true,
      checkoutNeeded: 'yes',
      features: {
        'No of Tests,Create your own': '20 / month',
        'Teacher Assisted Tests': '0',
        'Max No of Children': '5',
        'Track performance': 'Yes',
        'Maintain revision notes': 'Yes',
        'Weekly email updates': 'Yes',
        'Email support': 'Yes',
        'Detailed Performance analytics': 'Yes',
        'Adaptive Exam Planner': 'Yes',
        'Upload Worksheets,tailored feedback by Teacher': 'X',
      }
    },
    {
      title: 'Family Teacher assisted',
      code: 'family_teacher_assisted',
      price: 'A$19.99',
      period: '/month',
      duration: 'monthly',
      buttonText: 'Sign Up',
      checkoutNeeded: 'yes',
      features: {
        'No of Tests,Create your own': '20 / month',
        'Teacher Assisted Tests': '10 / month',
        'Max No of Children': '5',
        'Track performance': 'Yes',
        'Maintain revision notes': 'Yes',
        'Weekly email updates':'Yes',
        'Email support': 'Yes',
        'Detailed Performance analytics': 'Yes',
        'Adaptive Exam Planner': 'Yes',
        'Upload Worksheets,tailored feedback by Teacher': 'Yes',
      }
    }
  ],
  Champions: [
    {
      title: 'Champion',
      code: 'champion_free',
      price: 'Free',
      period: '',
      duration: 'onetime',
      buttonText: 'Become a Champion',
      checkoutNeeded: 'no',
      features: {
        'Full platform access': 'Yes',
        'Invite students & teachers': 'Unlimited',
        'Earn rewards for referrals': 'Yes',
        'Track referral performance': 'Yes',
        'Exclusive champion benefits': 'Yes',
        'No subscription required': 'Yes',
        'Help others succeed': 'Yes',
        'Build your network': 'Yes'
      }
    }
  ]
};

// Add-ons for each user type
export const ADD_ONS = {
  Teacher: [
    {
      title: 'Tests',
      description: 'A$2 / Test',
      buttonText: 'Add Tests'
    },
    {
      title: 'Students',
      description: 'A$1 / Student',
      buttonText: 'Add Students'
    }
  ],
  Student: [
    {
      title: 'Self tests',
      description: 'A$2 / Test',
      buttonText: 'Add Self Tests'
    },
    {
      title: 'Teacher Assisted Tests',
      description: 'A$4 / Test',
      buttonText: 'Add Assisted Tests'
    }
  ],
  Parent: [
    {
      title: 'Self tests',
      description: 'A$2 / Test',
      buttonText: 'Add Self Tests'
    },
    {
      title: 'Teacher Assisted Tests',
      description: 'A$4 / Test',
      buttonText: 'Add Assisted Tests'
    }
  ],
  Champions: [
    {
      title: 'Referral Rewards',
      description: 'Earn rewards for every successful referral'
    },
    {
      title: 'Question Rewards',
      description: 'For every approved question, points get accumulated that can be used for earning'
    }
  ]
};

// Plans that don't require payment redirection (free plans)
export const BYPASS_PAYMENT_PLANS = [
  'teacher_starter',
  'student_starter',
  'parent_starter',
  'family_starter',
  'champion_free'
];

// Helper function to check if a plan requires payment
export const requiresPayment = (planCode) => {
  return !BYPASS_PAYMENT_PLANS.includes(planCode);
};

// Helper function to check if a plan requires checkout
export const requiresCheckout = (planCode) => {
  const plan = getPlanByCode(planCode);
  return plan ? plan.checkoutNeeded === 'yes' : false;
};

// Helper function to get plan details by code
export const getPlanByCode = (planCode) => {
  for (const role in PRICING_PLANS) {
    const plan = PRICING_PLANS[role].find(p => p.code === planCode);
    if (plan) return plan;
  }
  return null;
};

/**
 * Get display config for a plan from the same source as Get Started / Pricing.
 * Returns { title, price, period, features } for UI, or null if no match.
 *
 * roleName: e.g. 'Student', 'Teacher', 'Parent'.
 * We first try to resolve the plan inside PRICING_PLANS[roleName] so that
 * overlapping codes (like family_* shared between Student and Parent)
 * use the correct feature set for that role.
 */
export const getPlanDisplayConfig = (planCode, roleName = 'Student') => {
  let plan = null;

  if (roleName) {
    const roleKey = roleName.charAt(0).toUpperCase() + roleName.slice(1).toLowerCase();
    const rolePlans = PRICING_PLANS[roleKey];
    if (Array.isArray(rolePlans)) {
      plan = rolePlans.find(p => p.code === planCode) || null;
    }
  }

  // Fallback: search all roles if not found for the specific role
  if (!plan) {
    plan = getPlanByCode(planCode);
  }

  if (!plan) return null;

  const isFamilyPlan = typeof planCode === 'string' && planCode.toLowerCase().startsWith('family_');
  const displayTitle = isFamilyPlan ? plan.title : (roleName ? `${roleName} ${plan.title}` : plan.title);
  return {
    title: displayTitle,
    price: plan.price,
    period: plan.period || '',
    features: plan.features || {}
  };
};

// Helper function to get all plans as a flat array
export const getAllPlans = () => {
  const allPlans = [];
  for (const role in PRICING_PLANS) {
    allPlans.push(...PRICING_PLANS[role]);
  }
  return allPlans;
};

// Legacy support for existing code
export const SUBSCRIPTION_PLANS = [
  {
    code: 'BASIC_MONTHLY',
    name: 'Basic Monthly',
    price: 9.99,
    duration: 'monthly',
    features: ['Access to basic lessons', 'Email support'],
    active: true,
  },
  {
    code: 'PREMIUM_MONTHLY',
    name: 'Premium Monthly',
    price: 19.99,
    duration: 'monthly',
    features: ['All lessons', 'Priority support', 'Practice tests'],
    active: true,
  },
  {
    code: 'PREMIUM_ANNUAL',
    name: 'Premium Annual',
    price: 199.99,
    duration: 'annual',
    features: ['All lessons', 'Priority support', 'Practice tests', 'Annual discount'],
    active: true,
  },
];
  
